import { Input } from '@builder.io/sdk';

import { moleculeHeadingFields } from 'molecules/Heading/config';
import sectionFields from 'molecules/Section/config';

import { idField } from 'utils/builder/fields';

export const cardCarouselFields = [
  ...moleculeHeadingFields,

  {
    name: 'items',
    type: 'list',
    helperText: 'Add any number of tiles. Desktop shows an animated carousel; mobile shows a vertical list.',
    subFields: [
      idField,
      {
        name: 'title',
        type: 'string',
        defaultValue: 'Build an integration marketplace',
        helperText: 'Card title',
      },
      {
        name: 'description',
        type: 'richText',
        defaultValue:
          '<p>Launch self-service integration marketplaces where customers can browse, activate, configure integrations.</p>',
        helperText: 'Supporting copy',
      },
      {
        name: 'buttonLabel',
        type: 'string',
        defaultValue: 'Learn more',
        helperText: 'CTA label',
      },
      {
        name: 'buttonHref',
        type: 'url',
        defaultValue: 'https://prismatic.io/',
        helperText: 'CTA link URL',
      },
    ],
  },

  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const cardCarouselConfig = {
  name: 'CardCarousel',
  inputs: cardCarouselFields,
};

export type CardCarouselConfig = GenerateBuilder<typeof cardCarouselFields>;

export default cardCarouselConfig;
